export type Step = {
  title: string
  description: string
}

export const process: Step[] = [
  {
    title: 'Vous appelez, je décroche',
    description:
      'C’est moi au téléphone, pas un centre d’appel. Quelques questions sur votre porte suffisent à identifier la serrure.',
  },
  {
    title: 'Prix et créneau annoncés',
    description:
      'Vous connaissez le montant et l’heure d’arrivée avant que je prenne la route. Sans engagement de votre part.',
  },
  {
    title: 'Devis écrit sur place',
    description:
      'J’examine la porte, je confirme le diagnostic et vous signez un devis. Aucun travail ne commence avant.',
  },
  {
    title: 'Intervention et facture',
    description:
      'Ouverture ou pose réalisée, chantier nettoyé, facture détaillée remise immédiatement. Pièces garanties 2 ans.',
  },
]
